export const toUppercaseFirstLetter = (word: string) =>
  word
    .split('')
    .map((char, i) => (i === 0 ? char.toUpperCase() : char))
    .join('');

export const separateWordFromString = (msg = '', word: string) => {
  const ifWordExists = msg.match(new RegExp(word, 'i'));
  const [backString, frontString] = msg.split(new RegExp(word, 'i'));

  return {
    word: ifWordExists ? word : '',
    backString,
    frontString,
  };
};

export const removeNonAsciiChars = (s: string) =>
  // eslint-disable-next-line no-control-regex
  s.replace(/[^\x00-\x7F]/g, '');
